import { PromoBanner } from 'components/banner/PromoBanner';
import { asText } from 'components/rich-text/RichText';
import { PageSlicesPromo_Banner } from 'prismic-types';
import { PrismicLink } from 'prismic/types/link';
import { PrismicRichText } from 'prismic/types/richtext';

type Props = {
  title: PrismicRichText;
  content: PrismicRichText;
  link_text?: string;
  link_to?: PrismicLink;
  color_theme?: string;
};

export type PromoBannerSlice = PageSlicesPromo_Banner;

export const PromoBannerSlice = ({
  title,
  content,
  link_text,
  link_to,
  color_theme = 'green',
}: Props) => {
  return (
    <PromoBanner
      title={asText(title)}
      content={content}
      linkText={link_text}
      linkTo={link_to}
      colorTheme={color_theme}
    />
  );
};

export const prismicSliceToPromoBanner = (s: PromoBannerSlice) => {
  const title = (s.variation?.primary?.title ?? null) as PrismicRichText;
  const content = (s.variation?.primary?.content ?? null) as PrismicRichText;

  if (!title && !content) {
    return null;
  }

  return (
    <PromoBannerSlice
      title={title}
      content={content}
      link_text={s.variation?.primary?.link_text ?? undefined}
      link_to={s.variation?.primary?.link_to ?? undefined}
      color_theme={s.variation?.primary?.color_theme ?? undefined}
    />
  );
};
